export const environment = {
  production: true,
  baseUrl: 'https://crm-backend-qa-971559558975.us-west1.run.app',
  baseUrlSM: 'https://social.isoft-ste.com',
  baseUrlSMC: 'https://social-proda.isoft-ste.com',
  socketUrlSM: 'https://realtimesm.isoft-ste.com',
  baseUrlClientIsoft: 'https://wsclientisoft-qa-318191231748.us-east4.run.app',
  baseUrlPGV: 'https://api.qamastech.masmovilpa.com',
  baseUrlPGViFrame: 'https://cperecovery-qa-iframes-971559558975.us-west1.run.app',
  whatsappSenderId: '50768738032',
  whatsappSenderBaseUrl: 'https://social-wpg.isoft-ste.com/gs',
  // AWS credentials moved to /assets/config.json (loaded at runtime via ConfigService)
  wexBaseUrl: 'https://ginacr.wex.services',
  consentimientoBaseUrl: 'http://10.106.196.122:8081',
  authBaseUrl: 'http://10.106.196.83:8190',
};
